<template>
  <PaginationButtons :previous-page-link="prevPageLink" :next-page-link="nextPageLink" nuxt />
</template>

<script setup lang="ts">
import { PaginationButtons } from '@ramp106/omrjs-core-ui'
import { jobsHrPaths } from '@ramp106/omrjs-routing'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const route = useRoute()
const { locale } = useI18n()

const props = defineProps<{
  page: number
  perPage: number
  total: number
}>()

const prevPageLink = computed(() => {
  if (props.page === 1) return ''

  return jobsHrPaths.jobsPaginated({ locale: locale.value, page: (props.page - 1).toString() }, route.query)
})
const nextPageLink = computed(() => {
  if (props.page * props.perPage >= props.total) return ''

  return jobsHrPaths.jobsPaginated({ locale: locale.value, page: (props.page + 1).toString() }, route.query)
})
</script>
